var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSentimentAnalysisIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 65,
    viewBox: "0 0 77 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.3169 46.6563C64.2143 55.5757 55.2792 61.1017 46.3598 58.9991C37.4405 56.8964 31.9144 47.9614 34.0171 39.042C36.1197 30.1227 45.0548 24.5966 53.9741 26.6992C62.8935 28.8019 68.4195 37.737 66.3169 46.6563Z",
    fill: "#3B82C9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.5273 45.6936C46.1543 45.205 47.8813 45.1529 49.5348 45.5427C51.1883 45.9325 52.7102 46.7505 53.9476 47.9144C55.1851 49.0784 56.0945 50.5474 56.5847 52.174C56.5847 52.174 54.668 52.7516 53.9369 52.9719C53.5867 51.8099 52.9369 50.7604 52.0529 49.9288C51.1688 49.0972 50.0816 48.5129 48.9003 48.2344C47.7189 47.9559 46.4852 47.9931 45.3228 48.3422C44.1604 48.6913 43.1103 49.3401 42.2779 50.2234C42.2779 50.2234 40.821 48.8505 40.2652 48.3267C41.4303 47.0904 42.9002 46.1823 44.5273 45.6936Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4302 40.0759C45.5452 40.3387 46.662 39.6479 46.9249 38.533C47.1877 37.4181 46.4969 36.3012 45.382 36.0384C44.2671 35.7756 43.1502 36.4663 42.8874 37.5812C42.6246 38.6962 43.3153 39.813 44.4302 40.0759Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5396 42.9313C57.6545 43.1942 58.7714 42.5034 59.0342 41.3885C59.2971 40.2736 58.6063 39.1567 57.4914 38.8939C56.3765 38.631 55.2596 39.3218 54.9968 40.4367C54.7339 41.5516 55.4247 42.6685 56.5396 42.9313Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4302 40.0759C45.5452 40.3387 46.662 39.6479 46.9249 38.533C47.1877 37.4181 46.4969 36.3012 45.382 36.0384C44.2671 35.7756 43.1502 36.4663 42.8874 37.5812C42.6246 38.6962 43.3153 39.813 44.4302 40.0759Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5396 42.9313C57.6545 43.1942 58.7714 42.5034 59.0342 41.3885C59.2971 40.2736 58.6063 39.1567 57.4914 38.8939C56.3765 38.631 55.2596 39.3218 54.9968 40.4367C54.7339 41.5516 55.4247 42.6685 56.5396 42.9313Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8833 22.795C44.8541 31.7444 39.1969 40.597 30.2475 42.5678C21.298 44.5386 12.4455 38.8813 10.4747 29.9319C8.50389 20.9825 14.1612 12.1299 23.1106 10.1591C32.06 8.18831 40.9126 13.8456 42.8833 22.795Z",
    fill: "#8CBFFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.2746 28.45C34.0025 28.6811 35.9104 29.2869 35.9104 29.2869C35.3963 30.9061 34.4652 32.3615 33.2108 33.5071C31.9563 34.6527 30.4225 35.4481 28.7634 35.8134C27.1043 36.1788 25.3783 36.1013 23.7587 35.5887C22.139 35.076 20.6827 34.1463 19.536 32.8929L21.5764 31.0262C22.3956 31.9217 23.436 32.5859 24.5931 32.9521C25.7503 33.3184 26.9834 33.3738 28.1687 33.1127C29.354 32.8517 30.4497 32.2834 31.346 31.465C32.2422 30.6466 32.9073 29.6068 33.2746 28.45Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3083 26.3516C21.427 26.1053 22.1341 24.9987 21.8878 23.88C21.6414 22.7613 20.5348 22.0542 19.4162 22.3005C18.2975 22.5469 17.5903 23.6534 17.8367 24.7721C18.083 25.8908 19.1896 26.598 20.3083 26.3516Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4606 23.6753C33.5793 23.429 34.2865 22.3224 34.0401 21.2037C33.7938 20.0851 32.6872 19.3779 31.5685 19.6243C30.4498 19.8706 29.7427 20.9772 29.989 22.0959C30.2354 23.2145 31.3419 23.9217 32.4606 23.6753Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSentimentAnalysisIcon);
export default __webpack_public_path__ + "static/media/sentiment_analysis_icon.c1ed8423.svg";
export { ForwardRef as ReactComponent };